import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import HeaderLogoPanel from './HeaderLogoPanel';
import HeaderMiddlePanel from './HeaderMiddlePanel';
import HeaderRightPanel from './HeaderRightPanel';

const Header: React.FC = () => {
  const { theme } = useTheme();
  
  return (
    <header className={`sticky top-0 z-30 flex h-12 shrink-0 items-center border-b shadow-sm transition-colors duration-200 theme-bg-secondary bg-white border-0 border-b-1 ${theme === 'light' ? 'border-gray-200' : 'border-gray-700'}`}
         >
      {/* Header Logo Panel - Same width as Left Panel */}
      <HeaderLogoPanel />      
      {/* Header Middle Panel - Flexible width */}
      <HeaderMiddlePanel />
      {/* Header Right Panel - Same width as Right Panel */}
      <HeaderRightPanel />
    </header>
  );
};

export default Header; 
